import React from 'react';

export interface CodeBlockProps {
  /** Literal source text shown in a monospace block (not interpreted as rich text). */
  code: string;
  /** Optional language hint (e.g. csm) for accessibility / future highlighting. */
  language?: string | undefined;
  className?: string | undefined;
}

/**
 * Read-only monospace code fence for rich text {@code code-block} elements.
 */
const CodeBlock: React.FC<CodeBlockProps> = ({ code, language, className = '' }) => {
  const text = String(code ?? '');
  const ariaLabel = language ? `Code block (${language})` : 'Code block';

  return (
    <pre
      className={`rich-text-code-block ${className}`.trim()}
      data-testid="code-block"
      data-language={language || undefined}
      aria-label={ariaLabel}
    >
      <code className={language ? `language-${language}` : undefined}>{text}</code>
    </pre>
  );
};

export default CodeBlock;
